export default __webpack_public_path__ + "static/media/frame_zh_tw_sp-landscape.5367744a.png";